export default __webpack_public_path__ + "static/media/notepad.909d51c2.svg";